export default function LoadingSpinner({ text = "⏳" }) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: 40,
        color: "#64748b",
        fontSize: 16,
      }}
    >
      {text}
    </div>
  );
}
